<template>
  <div class="modal fade" id="change-user-trial" aria-hidden="false" aria-labelledby="exampleGrid" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title">
                  {{ $t("admin.index.users.change_trial_title") }}
                </h4>
              </div>
              <div class="col-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#change-user-trial')">
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <v-loading v-bind:isLoading="loading"></v-loading>
          <div class="row-mt-15" v-if="!loading">
            <div class="form-group form-material col-12">
              <label for="trial-period" class="control-label">
                {{ $t("admin.index.users.trial_period_months") }}
              </label>
              <input type="text" id="trial-period" class="form-control" v-model="user.trial_period">
            </div>
          </div>
        </div>
        <div class="modal-footer text-center">
          <button type="button" class="btn waves-effect waves-classic btn-cancel" @click.prevent="closeModal('#change-user-trial')" data-dismiss="modal" :disabled="smallLoading">{{ $t("button.cancel") }}</button>
          <button type="submit" class="btn btn-primary waves-effect waves-classic btn-save" @click.prevent="changeSubscriptionTrial" :disabled="smallLoading">
            {{$t("admin.index.users.change") }}
          </button>
          <v-loading :isLoading="smallLoading" :height="50" :width="50" :viewbox="'0 0 50 50'"
                     :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import mixin from "../../../mixins/mixin";
    import adminService from "../../../services/admin";

    export default {
        name: "ChangeSubscriptionTrial",
        data() {
          return {
            loading: false,
            smallLoading: false
          }
        },
        props: [
          'user'
        ],
        mixins: [mixin],
        components: {
          VLoading: require('components/loading/loading.vue'),
        },
        computed: {
          account: function () {
            return this.$store.state.account;
          }
        },
        methods: {
          async changeSubscriptionTrial() {
            this.smallLoading = true;
            await adminService.updateSubscriptionTrial(this, this.user);
            await this.$emit('getUsers');
          }
        }
    }
</script>

<style scoped>
  #change-user-trial .modal-body .form-group label {
    margin-bottom: 1px !important;
  }
</style>



// WEBPACK FOOTER //
// ChangeSubscriptionTrial.vue?256e3c4c